import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'addYearsToDate' })
export class AddYearsToDatePipe implements PipeTransform {

    transform(value: any, args: any[]): string {

        let datePipe = new DatePipe('en-US');

        let date: Date = new Date(value);
        let year: number = date.getFullYear();

        date.setFullYear(year + args[1]);

        return datePipe.transform(date, args[0]);

    }

}
